<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 21 20" fill="none">
    <path d="M3.56769 8.62291L4.3491 13.0546C4.49296 13.8704 5.27095 14.4152 6.08679 14.2713L9.07155 13.745M3.56769 8.62291L3.30722 7.14574C3.16336 6.3299 3.70812 5.55191 4.52395 5.40805L11.1714 4.23593C11.9872 4.09207 12.7652 4.63683 12.9091 5.45267L13.0393 6.19128C13.1113 6.5992 12.8389 6.98819 12.4309 7.06012L3.56769 8.62291Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.5 16C15.9853 16 18 13.9853 18 11.5C18 9.01473 15.9853 7 13.5 7C11.0147 7 9 9.01473 9 11.5C9 13.9853 11.0147 16 13.5 16Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.5 10V11.5L14.75 12.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ComingSoonIcon',
  props: {
    width: {
      type: Number,
      default: 21
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>